import React from 'react'
import PropTypes from 'prop-types'

export const ContentContainer = ({ children }) => (
  <div className="container page-v-padding ph2 ph3-tablet ph4-computer">{children}</div>
)

ContentContainer.propTypes = {
  children: PropTypes.node,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ContentContainer.js